"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalculatorRootPage = CalculatorRootPage;
exports.calculatorRootMetadata = calculatorRootMetadata;
const jsx_runtime_1 = require("react/jsx-runtime");
const app_1 = require("@kalkulacka-one/app");
const client_1 = require("@kalkulacka-one/app/client");
const navigation_1 = require("next/navigation");
const clock_1 = require("../clock.js");
const group_resolution_1 = require("../group-resolution.js");
const calculator_1 = require("../guards/calculator.js");
const load_group_calculators_1 = require("./load-group-calculators");
async function CalculatorRootPage({ endpoint, segments, locale, embedContext, routes, homepageHref, privacyHref, launcher }) {
    const groupKey = segments.second;
    const segment = segments.third;
    if (!groupKey || !segment)
        (0, navigation_1.notFound)();
    const [group, election] = await Promise.all([(0, app_1.ifFound)((0, app_1.loadCalculatorGroup)({ endpoint, group: groupKey })), (0, app_1.ifFound)((0, app_1.loadElection)({ endpoint, group: groupKey }))]);
    if (!group) {
        await (0, calculator_1.calculatorGuard)({ endpoint, key: segment, group: groupKey, prefixed: true });
        (0, navigation_1.redirect)((0, app_1.addLauncherParam)(routes.introduction(segments, locale), launcher));
    }
    const resolution = (0, group_resolution_1.resolveGroupSegment)({ group, election, segment });
    if (!resolution)
        (0, navigation_1.notFound)();
    if (resolution.kind === "calculator") {
        await (0, calculator_1.calculatorGuard)({ endpoint, key: resolution.key, group: groupKey, prefixed: true });
        (0, navigation_1.redirect)((0, app_1.addLauncherParam)(routes.introduction({ ...segments, third: resolution.key }, locale), launcher));
    }
    const calculators = await (0, load_group_calculators_1.loadGroupCalculators)({ endpoint, group: groupKey, keys: resolution.calculators.map((item) => item.key) });
    const picker = (0, app_1.calculatorPickerViewModel)(resolution.district, resolution.calculators, calculators, (key) => (0, app_1.addLauncherParam)(routes.introduction({ ...segments, third: key }, locale), (0, app_1.addLauncherParam)(routes.base(segments, locale), launcher)), (0, clock_1.now)());
    const headingTitle = election?.shortTitle ?? election?.title ?? group.title;
    const heading = headingTitle ? { title: headingTitle } : undefined;
    // In an embed only when opened from the district picker, so a partner embedding one district keeps the voter there.
    const backHref = embedContext.isEmbed ? launcher : routes.base({ first: segments.first, second: groupKey }, locale);
    return (0, jsx_runtime_1.jsx)(client_1.CalculatorPickerPage, { embedContext: embedContext, picker: picker, heading: heading, backHref: backHref, homepageHref: homepageHref, privacyHref: privacyHref });
}
async function calculatorRootMetadata({ endpoint, segments, canonical }) {
    if (!segments.second || !segments.third)
        return {};
    const [group, election] = await Promise.all([(0, app_1.ifFound)((0, app_1.loadCalculatorGroup)({ endpoint, group: segments.second })), (0, app_1.ifFound)((0, app_1.loadElection)({ endpoint, group: segments.second }))]);
    if (!group)
        return {};
    const resolution = (0, group_resolution_1.resolveGroupSegment)({ group, election, segment: segments.third });
    if (resolution?.kind !== "calculator-picker")
        return {};
    const title = resolution.district.title;
    const description = election?.description;
    const url = canonical.base(segments);
    return {
        title,
        description,
        alternates: { canonical: url },
        openGraph: { title, description, url },
        twitter: { card: "summary", ...(process.env.X_HANDLE && { site: process.env.X_HANDLE }), title, description },
    };
}
